import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Header from '../components/ui/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Terms of Service"
        description="Terms of Service for EmailValidator email validation service. Read our terms and conditions for using our email validation platform and services."
        keywords="terms of service, email validation terms, service terms, terms and conditions, email validator legal, user agreement"
        canonical="https://mailvalidator.octalchip.com/terms"
      />
      
      <Header />
        <div className="max-w-4xl mx-auto px-4 py-8">
          {/* Header */}
          <div className="mb-8">
            <Link to="/" className="inline-flex items-center text-primary hover:text-primary/80 transition-colors mb-4">
              <Icon name="ArrowLeft" size={16} className="mr-2" />
              Back to Home
            </Link>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-lg shadow-sm p-6 space-y-6">
            <section id="acceptance-of-terms">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using our email validation service, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section id="service-description">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Service Description</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Our service provides email validation and verification tools to help you maintain clean email lists and improve deliverability.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Single email validation</li>
                <li>Bulk email validation</li>
                <li>Real-time validation results</li>
                <li>Detailed validation reports</li>
              </ul>
            </section>

            <section id="free-plan">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Free Plan</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                We offer a free plan that includes:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>100 free validation credits per month</li>
                <li>No credit card required</li>
                <li>Basic validation features</li>
                <li>Standard support</li>
              </ul>
            </section>

            <section id="usage-guidelines">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Usage Guidelines</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                You agree to use our service responsibly and in compliance with applicable laws:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-1 ml-4">
                <li>Only validate emails you have permission to validate</li>
                <li>Respect rate limits and fair usage policies</li>
                <li>Do not use the service for spam or malicious purposes</li>
                <li>Maintain the security of your account credentials</li>
              </ul>
            </section>

            <section id="privacy-and-data">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Privacy and Data</h2>
              <p className="text-gray-700 leading-relaxed">
                We are committed to protecting your privacy. Please review our Privacy Policy for details on how we collect, use, and protect your data.
              </p>
            </section>

            <section id="service-availability">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Service Availability</h2>
              <p className="text-gray-700 leading-relaxed">
                We strive to maintain high service availability but cannot guarantee uninterrupted access. We may perform maintenance or updates that temporarily affect service availability.
              </p>
            </section>

            <section id="limitation-of-liability">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Our service is provided "as is" without warranties. We are not liable for any damages arising from the use of our service.
              </p>
            </section>

            <section id="changes-to-terms">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section id="contact-information">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have questions about these terms, please contact us through our support channels.
              </p>
            </section>
          </div>
        </div>
        <Footer />
    </div>
  );
};

export default Terms; 